import { useState } from 'react';
import { useSession } from '../lib/session.js';
import { Logo } from '../components/Logo.js';
import { ErrorBox, Field, useSubmit } from '../components/ui.js';

export function Login() {
  const { branding, login } = useSession();
  const [slug, setSlug] = useState(branding?.slug ?? '');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  /**
   * Lembrar vem MARCADO. Quem atende usa o próprio celular e refazer login todo
   * dia é o atrito que faz gente escolher senha fraca ou deixar anotada. Quem
   * estiver num computador de balcão desmarca — e o aviso abaixo diz isso.
   */
  const [lembrar, setLembrar] = useState(true);

  const { submit, saving, error } = useSubmit(async () => {
    await login(slug || (branding?.slug ?? ''), email, password, lembrar);
  });

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={submit}>
        <div className="brand">
          <Logo size={48} />
          <div>
            <div className="brand-name">{branding?.name ?? 'Auto Center GL'}</div>
            <div className="brand-sub">Painel de atendimento</div>
          </div>
        </div>

        <ErrorBox error={error} />

        {branding?.slug ? null : (
          <Field label="Identificador da loja" required>
            <input
              type="text"
              value={slug}
              onChange={(e) => setSlug(e.target.value)}
              autoComplete="organization"
              required
            />
          </Field>
        )}

        <Field label="E-mail" required>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            required
            autoFocus
          />
        </Field>

        <Field label="Senha" required>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </Field>
        <label className="lembrar">
          <input
            type="checkbox"
            checked={lembrar}
            onChange={(e) => setLembrar(e.target.checked)}
          />
          <span>
            Lembrar neste aparelho
            <small>Não marque em computador compartilhado.</small>
          </span>
        </label>


        <button type="submit" className="primary" disabled={saving} style={{ width: '100%' }}>
          {saving ? 'Entrando…' : 'Entrar'}
        </button>
      </form>
    </div>
  );
}
